export default [
  'active',
  'community_pool_only',
  'max_price',
  'max_sq_ft',
  'min_bathrooms',
  'min_bedrooms',
  'min_parking',
  'min_price',
  'min_sq_ft',
  'pending',
  'private_pool',
  'sold',
  'u',
  'upcoming',
  'north',
  'east',
  'south',
  'west',
  'fha_eligible',
  'gated_community',
];




/** WEBPACK FOOTER **
 ** ./javascripts/market/values/filter-params.js
 **/